import React, { FunctionComponent, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import logos from '../../media/logos-flag.png';
import logoSmall from '../../media/logo-small.png';
import Character from '../../components/character/Character';
import worldATitle from '../../media/world-a-title.png';
import worldBTitle from '../../media/world-b-title.png';
import worldCTitle from '../../media/world-c-title.png';
import worldDTitle2 from '../../media/world-d-title__2.png';
import controlButtonEdit from '../../media/control-button-edit.png';
import GameContext from '../../context/GameContext';
import { Worlds } from '../mode/Mode';
import Information from '../../components/common/Information';

interface LobbyProps {}

const Lobby: FunctionComponent<LobbyProps> = () => {
    const history = useHistory();
    const { playerName, handleMainSound } = useContext(GameContext);

    const handleNavigateToAvatarPage = () => {
        history.push(`${process.env.PUBLIC_URL}/avatar`);
    };

    const handleNavigateToQuestionnaire = (worldId: Worlds) => {
        history.push(`${process.env.PUBLIC_URL}/mode/${worldId}`);
    };

    return (
        <>
            <div className="page-container page-lobby animate__animated animate__fadeIn">
                <img
                    src={logos}
                    className="common-logos animate__animated animate__slideInDown"
                    alt="Héroes de la Cuenca"
                />
                <div className="logo-small animate__animated animate__slideInUp">
                    <img
                        src={logoSmall}
                        className="animate__animated animate__pulse animate__infinite"
                        alt="Héroes de la Cuenca"
                    />
                </div>
                <div className="lobby-character-menu animate__animated animate__backInUp">
                    <div
                        className="lobby-character-container"
                        onClick={handleNavigateToAvatarPage}
                        onMouseEnter={() => handleMainSound('play-pop-effect')}
                    >
                        <Character name={playerName} />
                        <div className="edit-character-menu">
                            <img
                                src={controlButtonEdit}
                                alt="Editar"
                                className="animate__animated animate__pulse animate__infinite edit-character-button"
                            />
                            <div className="edit-character-title">
                                Personaliza tu <br />
                                Héroe de la Cuenca
                            </div>
                        </div>
                    </div>
                </div>
                <div className="lobby-worlds-menu animate__animated animate__backInLeft">
                    <img
                        className="animate__custom_hover_scale world-title"
                        src={worldDTitle2}
                        alt="Alta montaña (glaciar)"
                        onClick={() => handleNavigateToQuestionnaire('glaciar')}
                        onMouseEnter={() => handleMainSound('play-pop-effect')}
                    />
                    <img
                        className="animate__custom_hover_scale world-title"
                        src={worldCTitle}
                        alt="Cuenca alta"
                        onClick={() => handleNavigateToQuestionnaire('cuenca-alta')}
                        onMouseEnter={() => handleMainSound('play-pop-effect')}
                    />
                    <img
                        className="animate__custom_hover_scale world-title"
                        src={worldBTitle}
                        alt="Cuenca media"
                        onClick={() => handleNavigateToQuestionnaire('cuenca-media')}
                        onMouseEnter={() => handleMainSound('play-pop-effect')}
                    />
                    <img
                        className="animate__custom_hover_scale world-title"
                        src={worldATitle}
                        alt="Cuenca baja"
                        onClick={() => handleNavigateToQuestionnaire('cuenca-baja')}
                        onMouseEnter={() => handleMainSound('play-pop-effect')}
                    />
                </div>
            </div>
            <Information helpText="Puedes personalizar tu avatar haciendo clic en el ícono de la parte inferior del mismo. También puedes ingresar a los distintos niveles de la Cuenca haciendo clic sobre las placas que tienen sus respectivos nombres." />
        </>
    );
};

export default Lobby;
